module.exports = __webpack_public_path__ + "img/56fc835dNe349b797.e494940f.jpg";